import { useEffect } from 'react';

export const useMutationObserver = (
  targetRef: React.RefObject<HTMLElement | null>,
  callback: (node: MutationRecord) => void
) => {
  useEffect(() => {
    if (!targetRef.current) return;

    const observer = new MutationObserver((mutations) =>
      mutations.forEach(callback)
    );

    observer.observe(targetRef.current, {
      attributes: true,
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
    };
  }, [callback, targetRef]);
};
